//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoTabsBasic from './demos/DemoTabsBasic.vue'
import DemoTabsIcons from './demos/DemoTabsIcons.vue'
import DemoTabsFixed from './demos/DemoTabsFixed.vue'
import DemoTabsGrow from './demos/DemoTabsGrow.vue'
import DemoTabsIconAndText from './demos/DemoTabsIconAndText.vue'
import DemoTabsPagination from './demos/DemoTabsPagination.vue'
import DemoTabsVertical from './demos/DemoTabsVertical.vue'
import DemoTabsAlignment from './demos/DemoTabsAlignment.vue'
import DemoTabsProgrammaticNavigation from './demos/DemoTabsProgrammaticNavigation.vue'
import DemoTabsDynamic from './demos/DemoTabsDynamic.vue'

// code
import {
  tabsBasic,
  tabsIcons,
  tabsFixed,
  tabsGrow,
  tabsIconAndText,
  tabsPagination,
  tabsAlignment,
  tabsVertical,
  tabsProgrammaticNavigation,
  tabsDynamic,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoTabsBasic,
    DemoTabsIcons,
    DemoTabsFixed,
    DemoTabsGrow,
    DemoTabsIconAndText,
    DemoTabsPagination,
    DemoTabsVertical,
    DemoTabsAlignment,
    DemoTabsProgrammaticNavigation,
    DemoTabsDynamic,
  },
  setup() {
    return {
      codeSnippets: {
        tabsBasic,
        tabsIcons,
        tabsFixed,
        tabsGrow,
        tabsIconAndText,
        tabsPagination,
        tabsAlignment,
        tabsVertical,
        tabsProgrammaticNavigation,
        tabsDynamic,
      },
    }
  },
}
